import React from 'react';
import { 
  Building2, 
  Plus, 
  MapPin, 
  Phone, 
  Clock, 
  Pencil, 
  Trash2 
} from 'lucide-react';
import './Locations.css';

const Locations = () => {
  const branches = [
    {
      id: 1,
      name: 'CONSULTORIOS EXT...',
      address: 'Av. Libertador 1234, CABA',
      phone: '011 4444-5555',
      hours: 'Lun-Vie 09:00 - 20:00',
      status: 'PRINCIPAL',
      type: 'primary'
    },
    {
      id: 2,
      name: 'CENTRO MÉDICO NORTE',
      address: 'Pte. Perón 567, San Isidro',
      phone: '011 4777-8888',
      hours: 'Lun-Sab 08:00 - 21:00',
      status: 'ACTIVA',
      type: 'active'
    },
    {
      id: 3,
      name: 'SEDE CENTRAL',
      address: 'Santa Fe 2345, CABA',
      phone: '011 4888-9999',
      hours: '24hs',
      status: 'ACTIVA',
      type: 'active'
    }
  ];

  return (
    <div className="locations-page">
      <div className="locations-header">
        <div className="locations-title-container">
          <h1 className="locations-title">Sucursales y Sedes</h1>
          <p className="locations-subtitle">Gestiona los puntos de atención de tu red médica.</p>
        </div>
        <button className="btn-add-location">
          <Plus size={18} /> AGREGAR SUCURSAL
        </button>
      </div>

      <div className="locations-grid">
        {branches.map((branch) => (
          <div key={branch.id} className="location-card">
            <div className="card-header">
              <div className="location-icon-wrapper">
                <Building2 size={24} className="location-icon" />
              </div>
              <span className={`status-tag ${branch.type}`}>
                {branch.status}
              </span>
            </div>
            
            <div className="card-content">
              <h2 className="location-name">{branch.name}</h2>
              
              <div className="location-info-item">
                <MapPin size={18} className="info-icon" />
                <span>{branch.address}</span>
              </div>
              
              <div className="location-info-item">
                <Phone size={18} className="info-icon" />
                <span>{branch.phone}</span>
              </div>
              
              <div className="location-info-item">
                <Clock size={18} className="info-icon" />
                <span>{branch.hours}</span>
              </div>
            </div>

            <div className="card-footer">
              <button className="btn-edit-location">
                <Pencil size={16} /> EDITAR
              </button>
              <button className="btn-delete-location">
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Locations;
